<div class="layout">
    <div
        *ngIf="(isLoading$ | async) === false"
        class="main-wrapper"
        [ngClass]="{
            'login-wrapper': isLoginWrapper,
            reducedMenu: (isMenuOpen$ | async) === false,
            submenu: hasSubMenu
        }"
    >
        <app-headers></app-headers>
        <app-side-nav *ngIf="!isLoginWrapper" [ngClass]="{ reducedMenu: (isMenuOpen$ | async) === false }"></app-side-nav>
        <router-outlet></router-outlet>
    </div>
    <!--temporary hiding-->
    <!--<app-footer *ngIf="(isLoading$ | async) === false && (isAuth$ | async) === false"></app-footer>-->
    <app-wana-modal></app-wana-modal>
    <app-loader></app-loader>
    <app-error></app-error>
</div>
